import { useCallback, useMemo, useState } from "react"
import { columnsCollectionAdministrationTableFilters, columnsCollectionAdministrationTableHelper } from "../helpers/columnsCollectionAdministrationTableHelper"
import { defaulStateTable } from "@constants/defaultStates"
import { checkParams, getColumnsFilter } from "@thelpers/customTableHelper"
import { useCollectionAdministrationServices } from "./useCollectionAdministrationServices"
import { tabsCollectionAdministrationItems } from "../helpers/tabsCollectionAdministrationItems"
import useRedirectTo from "@thooks/useRedirectTo"

export const useCollectionAdministrationTable = () => {

    const { handleRedirectTo } = useRedirectTo()
    const {
        getAllChargesService,
        getDeletedChargesService,
        getChargeStatusListService,
        updateChargeStatusService,
        deleteChargeService
    } = useCollectionAdministrationServices()

    const [collectionAdministrationTable, setCollectionAdministrationTable] = useState(structuredClone(defaulStateTable))
    const [chargeStatusData, setChargeStatusData] = useState([])

    const [loadingCollectionAdministrationTable, setLoadingCollectionAdministrationTable] = useState(false);
    const serviceParams = useMemo(() => ({
        previousData: collectionAdministrationTable.dataTable,
        actualLimit: collectionAdministrationTable.metadata.limit,
        limit: collectionAdministrationTable.metadata.limit,
        currentPage: collectionAdministrationTable.currentPage,
        skip: 0
    }), [collectionAdministrationTable])

    const getInitialData = useCallback(async ({ status, charge_status_id }) => {
        setLoadingCollectionAdministrationTable(true)
        const getService = status === 'deleted' && !charge_status_id ? getDeletedChargesService : getAllChargesService
        const { data, metadata } = await getService({ setLoading: setLoadingCollectionAdministrationTable, charge_status_id, previousData: collectionAdministrationTable.dataTable, currentPage: collectionAdministrationTable.currentPage, limit: 10 })
        const defaultData = structuredClone(defaulStateTable)
        setCollectionAdministrationTable({
            ...defaultData,
            dataTable: data.dataSource,
            currentParams: {
                ...defaulStateTable.currentParams,
                status,
                charge_status_id
            },
            metadata,
        })
        setLoadingCollectionAdministrationTable(false)
        if (chargeStatusData.length) return
        const resStatus = await getChargeStatusListService({ setLoading: setLoadingCollectionAdministrationTable })
        setChargeStatusData(resStatus)
    }, [getAllChargesService, getDeletedChargesService, getChargeStatusListService, chargeStatusData, collectionAdministrationTable.dataTable, collectionAdministrationTable.currentPage])

    const handleUpdateChargeStatus = useCallback(async ({ charge_id, isDeleted }) => {
        setLoadingCollectionAdministrationTable(true)
        const service = isDeleted ? deleteChargeService : updateChargeStatusService
        await service({ charge_id, setLoading: setLoadingCollectionAdministrationTable })
        await getInitialData({ status: collectionAdministrationTable.currentParams.status })

    }, [
        updateChargeStatusService,
        deleteChargeService,
        getInitialData,
        collectionAdministrationTable
    ])

    const handleChangeTable = useCallback(async ({ pagination, filter, sorter }) => {
        let sort_order
        if (sorter.order === 'descend') sort_order = 'desc'
        if (sorter.order === 'ascend') sort_order = 'asc'

        const sort_by = sorter.column?.key
        const pageValue = pagination.current || collectionAdministrationTable.currentPage
        const newSkip = (pageValue * parseFloat(collectionAdministrationTable.metadata.limit)) - parseFloat(collectionAdministrationTable.metadata.limit)
        const actualParams = { ...collectionAdministrationTable.currentParams }
        const newParams = {
            //Se agrega el nuevo parametro de busqueda
            ...actualParams,
            find_by: actualParams.find_by ?? undefined,
            find_value: actualParams.find_value ?? undefined,
            sort_by,
            sort_order,
            skip: 0
        }
        let newPage = 1

        const finalParams = { ...serviceParams, ...newParams }

        if (checkParams({ actualParams, newParams, difKey: 'skip' })) {
            newPage = pageValue
            finalParams.skip = newSkip
        }

        setLoadingCollectionAdministrationTable(true)
        const getService = collectionAdministrationTable.currentParams.status === 'deleted' ? getDeletedChargesService : getAllChargesService
        const { data, metadata } = await getService({ ...finalParams, setLoading: setLoadingCollectionAdministrationTable })
        setCollectionAdministrationTable({
            ...collectionAdministrationTable,
            currentPage: newPage,
            dataTable: data.dataSource,
            metadata: metadata,
            currentParams: newParams,

        })
        setLoadingCollectionAdministrationTable(false)
    }, [
        collectionAdministrationTable,
        serviceParams,
        getAllChargesService,
        getDeletedChargesService
    ])

    const handleChangeTabs = async (key) => {
        await getInitialData({ status: key })
    }

    const columns = useMemo(() => columnsCollectionAdministrationTableHelper({
        columns: collectionAdministrationTable.columns,
        handleRedirectTo,
        onRestore: handleUpdateChargeStatus,
        onDelete: handleUpdateChargeStatus,
        onEnableDisable: handleUpdateChargeStatus,
        isDelete: collectionAdministrationTable.currentParams?.status === 'deleted'
    }).map((column) => ({
        ...column,
        ...getColumnsFilter(column.dataIndex, columnsCollectionAdministrationTableFilters({ currentParams: collectionAdministrationTable.currentParams }))
    })), [collectionAdministrationTable, handleRedirectTo, handleUpdateChargeStatus])

    const tabItems = useMemo(() => tabsCollectionAdministrationItems({
        handleChangeTable,
        columns,
        statusItems: chargeStatusData,
        getInitialData,
        loadingCollectionAdministrationTable,
        collectionAdministrationTable
    }),
        [
            handleChangeTable,
            getInitialData,
            chargeStatusData,
            columns,
            loadingCollectionAdministrationTable,
            collectionAdministrationTable
        ])

    return {
        loadingCollectionAdministrationTable,
        tabItems,
        getInitialData,
        handleChangeTabs,
    }
}